import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { ExpandingFAQ, FrequentlyAskedQuestionsContainer } from './FrequentlyAskedQuestions';
import { useFaqToggleHandler, useLinkClickHandler } from './FrequentlyAskedQuestionsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CommerceHubFaqs = ({
  onLinkClick,
  onFaqInteraction
} = {}) => {
  const handleFaqToggle = useFaqToggleHandler(onFaqInteraction);
  const handleLinkClick = useLinkClickHandler(onLinkClick);
  return /*#__PURE__*/_jsxs(FrequentlyAskedQuestionsContainer, {
    children: [/*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.commerce.whatIsCommerceHubProduct.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.commerce.whatIsCommerceHubProduct.answer"
      }),
      onExpandedChange: () => handleFaqToggle('commerce.whatIsCommerceHubProduct', 'pricing-page-components.frequentlyAskedQuestions.commerce.whatIsCommerceHubProduct.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.commerce.whatIsFreeVsPaidUser.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.commerce.whatIsFreeVsPaidUser.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {})
        }
      }),
      onExpandedChange: () => handleFaqToggle('commerce.whatIsFreeVsPaidUser', 'pricing-page-components.frequentlyAskedQuestions.commerce.whatIsFreeVsPaidUser.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.commerce.howManyCommerceUsers.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.commerce.howManyCommerceUsers.answer"
      }),
      onExpandedChange: () => handleFaqToggle('commerce.howManyCommerceUsers', 'pricing-page-components.frequentlyAskedQuestions.commerce.howManyCommerceUsers.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.commerce.salesVsCommerceHub.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.commerce.salesVsCommerceHub.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {})
        }
      }),
      onExpandedChange: () => handleFaqToggle('commerce.salesVsCommerceHub', 'pricing-page-components.frequentlyAskedQuestions.commerce.salesVsCommerceHub.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.commerce.hubspotVsStripePayments.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.commerce.hubspotVsStripePayments.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          contactCommerceTeam: /*#__PURE__*/_jsx(Link, {
            href: "mailto:commerceteam@hubspot.com",
            onClick: () => handleLinkClick('commerce.hubspotVsStripePayments.contactCommerceTeam', 'mailto:commerceteam@hubspot.com'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.commerce.hubspotVsStripePayments.contactCommerceTeam"
            })
          })
        }
      }),
      onExpandedChange: () => handleFaqToggle('commerce.hubspotVsStripePayments', 'pricing-page-components.frequentlyAskedQuestions.commerce.hubspotVsStripePayments.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.commerce.stripeCustomRates.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.commerce.stripeCustomRates.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          stripeSupport: /*#__PURE__*/_jsx(Link, {
            href: "https://support.stripe.com/",
            external: true,
            onClick: () => handleLinkClick('commerce.stripeCustomRates.stripeSupport', 'https://support.stripe.com/'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.commerce.stripeCustomRates.stripeSupport"
            })
          })
        }
      }),
      onExpandedChange: () => handleFaqToggle('commerce.stripeCustomRates', 'pricing-page-components.frequentlyAskedQuestions.commerce.stripeCustomRates.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.commerce.commerceHubToolsIndependent.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.commerce.commerceHubToolsIndependent.answer"
      }),
      onExpandedChange: () => handleFaqToggle('commerce.commerceHubToolsIndependent', 'pricing-page-components.frequentlyAskedQuestions.commerce.commerceHubToolsIndependent.question')
    })]
  });
};